"use client";

import React, { useRef } from "react";
import { MethodologySection } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { renderRichText } from "@/lib/richText";
import Slider from "react-slick";

interface MethodologySectionProps {
  blok?: MethodologySection & SbBlokData;
}

const MethodologySectionComponent: React.FC<MethodologySectionProps> = ({ blok }) => {
  const sliderRef = useRef<Slider | null>(null);
  if (!blok) return null;

  const { headline, subtitle, items } = blok;

  const settings = {
    adaptiveHeight: true,
    autoplay: false,
    dots: true,
    customPaging: (i: number) => {
      return <button type="button">{i + 1}</button>;
    },
    fade: true,
    lazyLoad: "ondemand" as const,
    draggable: false,
  };

  return (
    <>
    <div {...storyblokEditable(blok)} className="container">
      <div className="padding-medium">
        {headline && <h2 className="text-center">{headline}</h2>}
        {subtitle && (
          <div
            className="lead text-center mb-4"
            dangerouslySetInnerHTML={{ __html: renderRichText(subtitle) }}
          />
        )}
        <div className="methodology-and-service-slider mb-0 slick-slider slick-dotted">
          <Slider ref={sliderRef} {...settings}>
            {items?.map((item) => (
              <div key={item._uid} className="text-center pt-3">
                <div className="two-thirds-centered">
                  {item.title && (
                    <h3 className="dark-highight-text">{item.title}</h3>
                  )}
                  {item.description && (
                    <p className="mb-0">{item.description}</p>
                  )}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
    <hr/>
    </>
  );
};

export default MethodologySectionComponent;